import { get } from "@/api/implementation/app/index.js";

export const profile = (...args) => get(`profile`, ...args);
